import {
  DistinctFilterMetadata,
  FilterMetadata,
  PortfolioBreakdown,
  RangeFilterMetadata,
} from "../types";

export function isRangeFilterMetadata(
  metadata: FilterMetadata
): metadata is RangeFilterMetadata {
  return metadata.type === "range";
}

export function isDistinctFilterMetadata(
  metadata: FilterMetadata
): metadata is DistinctFilterMetadata {
  return metadata.type === "distinct";
}

export function findBreakdownByCategory(
  pBreakdown: PortfolioBreakdown[],
  category: string
): PortfolioBreakdown | null {
  for (const pb of pBreakdown) {
    if (pb.category === category) return pb;
    if (pb.breakdown) {
      const found = findBreakdownByCategory(pb.breakdown, category);
      if (found) return found;
    }
  }
  return null;
}
